import { Barn, Rider, Person } from "../../models";
import { formatShortAddress } from "../address/FormatAddress";
import { getPersonByPersonId } from "../person/Person";
import { formatDisplayNameForUser } from "../person/PersonNameFormat";
import { getRidersByBarnId, getRidersByPersonId } from "./Rider";
export interface formattedOption {
    value: string; //Rider's id
    label: string; //Used for filtering options as a user types
    riderName: string; //Rider's Full Name - will display when item is selected
    riderNameLabel?: string; //Rider's Full Name
    barnLabel?: string; //Barn Name - will display in options
    riderStatusLabel?: string; //Rider's status
    createdByLabel?: string;
    rider?: Rider;
}

export interface formattedGroupOfOptions {
    label: string;
    options: formattedOption[];
}

export async function getRidersCreatedByUserOrInCurrentBarn(user: Person, currentBarn?: (Barn | null | undefined), listOfRidersCreatedByUser?: (formattedOption[] | undefined)) {
    // First, get riders by User (check if riders created by the user were already passed in)
    let ridersCreatedByUser: (formattedOption[] | undefined) = listOfRidersCreatedByUser || [];
    if (ridersCreatedByUser.length === 0 && user) {
        ridersCreatedByUser = await getRidersCreatedByUser(user);
    }

    // Next, get riders by Barn
    let ridersByBarn: (formattedOption[] | undefined) = [];
    if (currentBarn != null && currentBarn != undefined) {
        ridersByBarn = await getRidersInCurrentBarn(currentBarn);
    }

    // Next, remove any duplicates by taking barn riders out of the list of created by riders
    const ridersCreatedByUserUpdatedList = await removeBarnRidersFromCreatedByGroup(ridersCreatedByUser, ridersByBarn);

    const sortedCreatedByList = ridersCreatedByUserUpdatedList.sort((a, b) => a.riderName.localeCompare(b.riderName));
    const sortedBarnList = ridersByBarn?.sort((a, b) => a.riderName.localeCompare(b.riderName));

    const result = {
        "createdBy": sortedCreatedByList,
        "barn": sortedBarnList
    };

    return result;
};

export async function getRidersCreatedByUser(user: Person) {
    try {
        let formattedList: formattedOption[] = [];
        const queryRidersByCreatedByUser = await getRidersByPersonId(user.id);
        if (queryRidersByCreatedByUser.isSuccess) {
            const result: Rider[] = queryRidersByCreatedByUser.result;
            formattedList = await formatRiders(result, user);
        }
        return formattedList;
    } catch (error) {
        console.error("Error fetching riders created by user:", error);
        return [];
    }
};

export async function getRidersInCurrentBarn(currentBarn: Barn) {
    try {
        let formattedList: formattedOption[] = [];
        if (currentBarn) {
            const queryRidersByBarn = await getRidersByBarnId(currentBarn.id);
            if (queryRidersByBarn.isSuccess) {
                const result: Rider[] = queryRidersByBarn.result;
                formattedList = await formatRiders(result);
            }
        }
        return formattedList;
    } catch (error) {
        console.error("Error fetching barn riders:", error);
    }
};

export async function removeBarnRidersFromCreatedByGroup(createdByList?: (formattedOption[] | null), barnRidersList?: (formattedOption[] | null)) {
    let result: formattedOption[] = createdByList || [];
    // Only need to handle this if both of the lists have items in them
    if (createdByList && createdByList.length > 0 && barnRidersList && barnRidersList.length > 0) {
        // Remove all of the barnRiders from the CreatedBy list
        result = createdByList?.filter((createdByRider) => !barnRidersList.some((barnRider) => barnRider.value === createdByRider.value));
    }
    return result;
};

// FORMATTERS
export async function formatRiders(riderArray: Rider[], user?: Person) {
    let formattedRiders = [];

    for (var i = 0; i < riderArray.length; i++) {
        const rider = riderArray[i];
        let object: formattedOption = await formatSingleRider(rider, user);
        formattedRiders.push(object);
    }

    return formattedRiders;
};

export async function formatSingleRider(rider: Rider, user?: Person) {
    const value = rider.id;
    const nameLabel = rider.name || "Unknown - No name found";
    const barnLabel = rider.barn ? rider.barn.name : "Unknown - No barn found";
    const statusLabel = rider.isProfessional === true ? "Professional" : (rider.isProfessional === false ? "Amateur" : "Unknown");
    let createdByLabel = "Unknown";
    
    // If the rider is in the CreatedBy group, then we know the user who created it.
    // Saves us from querying the DB any more times than needed
    if (user) {
        createdByLabel = formatDisplayNameForUser(user);
    }
    
    // If we only have the personId, then we will make the DB query to get the createdBy person's name
    if (createdByLabel == "Unknown" && rider.createdBy) {
        const personResult = await getPersonByPersonId(rider.createdBy);
        if (personResult.isSuccess) {
            const person: Person = personResult.result;
            createdByLabel = formatDisplayNameForUser(person);
        }
    }

    let object: formattedOption = {
        value: value,
        label: nameLabel,
        riderName: nameLabel,
        riderNameLabel: nameLabel,
        barnLabel: barnLabel,
        riderStatusLabel: statusLabel,
        createdByLabel: createdByLabel,
        rider: rider,
    };
    return object;
};